export default __webpack_public_path__ + "static/media/fantom.8ede659e.svg";